/** ⌘K umumiy qidiruv (backend: apps/core/search.py): bitta so'rov, bo'limlar alohida, har biri o'z doirasida. */
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { Role } from "@/features/auth/types";
import type { CarrierStatus, JobStatus } from "@/features/carriers/types";
import type { DriverStatus } from "@/features/drivers/types";

export interface SearchDriver {
  id: number;
  /** Aniq emas, eng yaqin o'xshash (xato yozilgan so'rov) */
  similar?: boolean;
  full_name: string;
  phone_display: string;
  state: string;
  status: DriverStatus;
}
export interface SearchPerson {
  id: number;
  /** Aniq emas, eng yaqin o'xshash (xato yozilgan so'rov) */
  similar?: boolean;
  full_name: string;
  role: Role;
  branch: string | null;
  is_blocked: boolean;
}
export interface SearchCarrier {
  id: number;
  /** Aniq emas, eng yaqin o'xshash (xato yozilgan so'rov) */
  similar?: boolean;
  name: string;
  mc_number: string;
  state: string;
  status: CarrierStatus;
}
export interface SearchJob {
  id: number;
  /** Aniq emas, eng yaqin o'xshash (xato yozilgan so'rov) */
  similar?: boolean;
  title: string;
  carrier_name: string;
  status: JobStatus;
}
export interface SearchSection<T> {
  /** Mos keluvchilar soni (ro'yxat cheklangan: "Barchasini ko'rish" uchun) */
  count: number;
  items: T[];
}
export interface SearchResults {
  q: string;
  drivers: SearchSection<SearchDriver>;
  people: SearchSection<SearchPerson>;
  carriers: SearchSection<SearchCarrier>;
  jobs: SearchSection<SearchJob>;
}

/** Backend bilan bir xil: qisqaroq so'rov yuborilmaydi */
export const MIN_QUERY = 2;

export const searchKeys = { all: (q: string) => ["search", q] as const };

export function useGlobalSearch(q: string, enabled: boolean) {
  return useQuery({
    queryKey: searchKeys.all(q),
    queryFn: () => api.get<SearchResults>("/api/search/", { query: { q } }),
    enabled: enabled && q.length >= MIN_QUERY,
    staleTime: 15_000,
    // Yozish davomida eski natija turadi, yangisi kelganda almashadi: ro'yxat "lipillamaydi"
    placeholderData: keepPreviousData,
  });
}
